import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/about/components/AboutInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
